import { render, staticRenderFns } from "./CancelOrder.vue?vue&type=template&id=926e4b40&scoped=true&"
import script from "./CancelOrder.vue?vue&type=script&lang=js&"
export * from "./CancelOrder.vue?vue&type=script&lang=js&"
import style0 from "./CancelOrder.vue?vue&type=style&index=0&id=926e4b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926e4b40",
  null
  
)

export default component.exports